<script lang="ts" setup>
// Core
import { ref, watch } from "vue";

// Components
import Icon from "@/components/core/IconCore.vue";

// Assets
import checkIcon from "@/assets/svg/icons/check_white.svg?url";

const checkboxProps = defineProps<{ id?: string; defaultValue?: boolean; disabled?: boolean; error?: boolean; size?: "small" }>();
const emit = defineEmits(["checkbox:update"]);

const checked = ref(checkboxProps.defaultValue ?? false);

const handleCheckboxUpdate = () => {
  checked.value = !checked.value;
  emit("checkbox:update", checked.value);
};

watch(
  () => checkboxProps.defaultValue,
  newValue => {
    if (newValue !== undefined) {
      checked.value = newValue;
    }
  }
);
</script>

<template>
  <div
    tabindex="0"
    role="button"
    :id="id"
    :disabled="disabled"
    :class="[
      'main-checkbox',
      { 'main-checkbox--checked': checked },
      { 'main-checkbox--disabled': disabled },
      { 'main-checkbox--error': error },
      { 'main-checkbox--small': size === 'small' }
    ]"
    @click="() => !disabled && handleCheckboxUpdate()"
    @keydown.enter="() => !disabled && handleCheckboxUpdate()"
  >
    <Icon v-if="checked" :icon-src="checkIcon" />
  </div>
</template>

<style lang="scss" scoped>
.main-checkbox {
  @include flex-center();
  @include square-size($icon_size_lmd);
  background: $new-neutral_0;
  border: 1px solid $new-neutral_3;
  border-radius: $br_xs;
  cursor: pointer;
  transition: $transition_duration_fast;

  &--checked {
    background: $new-green_7;
    border-color: $new-green_7;
  }

  &--disabled {
    cursor: not-allowed;
  }

  &--error {
    border-color: $red_7;
  }

  &--small {
    @include square-size($icon_size_md);
  }
}
</style>
